import { render, staticRenderFns } from "./arrow-left.vue?vue&type=template&id=6aa259fb&"
import script from "./arrow-left.vue?vue&type=script&lang=js&"
export * from "./arrow-left.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aa259fb')) {
      api.createRecord('6aa259fb', component.options)
    } else {
      api.reload('6aa259fb', component.options)
    }
    module.hot.accept("./arrow-left.vue?vue&type=template&id=6aa259fb&", function () {
      api.rerender('6aa259fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/arrow-left.vue"
export default component.exports